/**
 * The one count-cell formatter for bill tables (Reports > 3PL usage and
 * Settings > Billing): locale thousands separators, and a "-" for zero or
 * for nothing to show, never a blank cell (DESIGN.md §12, §14).
 */
export function formatCountCell(n: number): string {
  return n === 0 || !Number.isFinite(n) ? '-' : Math.round(n).toLocaleString();
}
